import Service from "../../../Services/index";

const Account = {
    namespaced: true,
    state: {
        paymentAccountTable: [],
        paymentAccountAll: [],
        paymentAccountType: [],
        paymentAccountForm: {
            id: "",
            account: "",
            name: "",
            account_type: null,
            details: [],
        },
        accountDetailsForm: {
            id: "",
            payment_account_id: "",
            account_number: "",
            name: "",
            account_full: ""
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
        mileSellerForm: {
            id: "",
            sale_id: "",
            date: "",
            gas_car_fee: "",
            mile_warehouse_out: "",
            mile_warehouse_in: "",
            distance_total: "",
            average_mile: "",
            free_km: "",
            over_gas_fee: "",
            user_id: "",
            user_update_id: "",
        },
        account_details: [],
        payoffAccountAll: [],
    },
    mutations: {
        GET_PAYMENT_ACCOUNT: (state, res) => {
            state.paymentAccountTable = res.data.map(account => ({
                ...account,
                show: 0
            }));
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
        GET_ACCOUNT_BY_ID: (state, res) => {
            state.paymentAccountForm = res;
        },
        GET_MILE_SELLER_BY_ID: (state, res) => {
            state.mileSellerForm = res;
        },
        GET_PAYMENT_ACCOUNT_ALL: (state, res) => {
            state.paymentAccountAll = res;
        },
        CLEAR_DATA: (state, menu) => {
            if (menu == 'income') {
                state.paymentAccountForm = {
                    id: "",
                    account: "",
                    name: "",
                    account_type: 4,
                    details: [],
                }
            } else {
                state.paymentAccountForm = {
                    id: "",
                    account: "",
                    name: "",
                    account_type: null,
                    details: [],
                }
            }
        },
        //Account Details
        GET_ACCOUNT_DETAILS_BY_ID: (state, res) => {
            state.accountDetailsForm = res;
        },
        CLEAR_ACCOUNT_DETAILS: (state, account_id) => {
            state.accountDetailsForm = {
                id: "",
                payment_account_id: account_id,
                account_number: "",
                name: "",
                account_full: "",
            }
        },
        GET_INVOICE_PAYOFF_ACCOUNT_ALL: (state, res) => {
            state.payoffAccountAll = res;
        },
        GET_PAYMENT_ACCOUNT_TYPE: (state, res) => {
            state.paymentAccountType = res;
        }
    },
    actions: {
        //paymentAccount
        getPaymentAccount({commit}, page = 1) {
            return Service.PaymentAccount.getPaymentAccount(page)
                .then(data => {
                    commit("GET_PAYMENT_ACCOUNT", data);
                })
        },
        getPaymentAccountById({commit}, id) {
            return Service.PaymentAccount.getPaymentAccountById(id)
                .then(data => {
                    commit("GET_ACCOUNT_BY_ID", data);
                })
        },
        savePaymentAccount({commit}, {id, data}) {
            if (!id) {
                return Service.PaymentAccount.createPaymentAccount(data)
            } else {
                return Service.PaymentAccount.updatePaymentAccount(id, data)
            }
        },
        deletePaymentAccount({commit}, id) {
            return Service.PaymentAccount.deletePaymentAccount(id);
        },
        search({commit}, {page = 1, data}) {
            return Service.PaymentAccount.searchPaymentAccount(page, data).then(res => {
                //console.log(res);
                commit("GET_PAYMENT_ACCOUNT", res);
            })
        },
        getPaymentAccountAll({commit}) {
            return Service.PaymentAccount.getPaymentAccountAll().then(res => {
                commit("GET_PAYMENT_ACCOUNT_ALL", res);
            })
        },
        clearData({commit}, menu) {
            commit("CLEAR_DATA", menu);
        },
        getPaymentAccountType({commit}) {
            return Service.PaymentAccount.getPaymentAccountType().then(res => {
                commit("GET_PAYMENT_ACCOUNT_TYPE", res);
            })
        },
        generatePaymentAccountNumber({commit}, account_type) {
            return Service.PaymentAccount.generatePaymentAccountNumber(account_type);
        },
        //Details
        getAccountDetailsById({commit}, id) {
            return Service.PaymentAccount.showPaymentAccountDetailsById(id).then(res => {
                commit("GET_ACCOUNT_DETAILS_BY_ID", res);
            })
        },
        saveAccountDetails({commit}, {id, data}) {
            if (!id) {//create
                return Service.PaymentAccount.createPaymentAccountDetails(data)
            } else {
                return Service.PaymentAccount.updatePaymentAccountDetails(id, data)
            }
        },
        deleteAccountDetails({commit}, id) {
            return Service.PaymentAccount.deletePaymentAccountDetails(id)
        },
        clearAccountDetails({commit}, account_id) {
            commit("CLEAR_ACCOUNT_DETAILS", account_id);
        },

        //InvoicePayoffAccount
        getInvoicePayoffAccount({commit}, {page = 1, data}) {
            return Service.InvoicePayoffOtherAccount.getInvoicePayoffOtherAccount(page, data).then(res => {
                commit("GET_PAYMENT_ACCOUNT", res)
            })
        },
        showInvoicePayoffAccount({commit}, id) {
            return Service.InvoicePayoffOtherAccount.showInvoicePayoffOtherAccount(id).then(res => {
                commit("GET_ACCOUNT_BY_ID", res)
            })
        },
        saveInvoicePayoffAccount({commit}, {id, data}) {
            if (!id) {
                return Service.InvoicePayoffOtherAccount.createInvoicePayoffOtherAccount(data)
            } else {
                return Service.InvoicePayoffOtherAccount.updateInvoicePayoffOtherAccount(id, data)
            }
        },
        deleteInvoicePayoffAccount({commit}, id) {
            return Service.InvoicePayoffOtherAccount.deleteInvoicePayoffOtherAccount(id);
        },
        getAllInvoicePayoffAccount({commit}) {
            return Service.InvoicePayoffOtherAccount.getAllAccount().then(data => {
                commit("GET_INVOICE_PAYOFF_ACCOUNT_ALL", data);
            })
        },

        //mile seller
        getMileSeller({commit}, {page = 1, data}) {
            return Service.PaymentAccount.getMileSeller(page, data);
        },
        saveMileSeller({commit}, {id, data}) {
            if (!id) {//create
                return Service.PaymentAccount.createMileSeller(data);
            } else {
                return Service.PaymentAccount.updateMileSeller(id, data)
            }
        },
        deleteMileSeller({commit}, id) {
            return Service.PaymentAccount.deleteMileSeller(id);
        },
        getMileSellerById({commit}, id) {
            return Service.PaymentAccount.getMileSellerById(id)
                .then(data => {
                    commit("GET_MILE_SELLER_BY_ID", data);
                    return data;
                })
        },
        getDriverReport({commit}, data) {
            return Service.PaymentAccount.getDriverReport(data)
        },

    }
};

export default Account
